export default __webpack_public_path__ + "static/media/bahujan-samajik-trust-logo.083e109a.jpg";